import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from 'components/TextField'
import DatePickerField from 'components/DatePickerField'
import FormSection from 'components/FormSection'
import MultiFieldsGroup from 'components/MultiFieldsGroup'
import WysiwygEditor from 'components/WysiwygEditor'
import Icon from '@material-ui/core/Icon'
import Typography from '@material-ui/core/Typography'
import InputLabel from '@material-ui/core/InputLabel';

const Employment = ({
  mutators
}) => (
  <FormSection
    sortable
    title={(
      <Typography variant="h6" component="h2">
        Doświadczenie zawodowe 
      </Typography> 
    )}
    subtitle={(
      <Typography component="p">
        Wpisz informacje o swoim doświadczeniu zawodowym, zacznij od ostatnich stanowisk.
      </Typography>
    )}
  >
    <MultiFieldsGroup
      name='employment'
      mutators={mutators}
      label='zatrudnienie'
      fieldToPreview='title'
      renderFieldsGroup={(name, index) => (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
            Nazwa stanowiska
            </InputLabel>
            <TextField
              name={`${name}.title`}
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
            Pracodawca
            </InputLabel>
            <TextField
              name={`${name}.employer`}
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputLabel shrink>
            Data rozpoczęcia
            </InputLabel>
            <DatePickerField
              name={`${name}.dateFrom`}
              label=""  className="dateInput"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputLabel shrink>
            Data zakończenia
            </InputLabel>
            <DatePickerField
              name={`${name}.dateTo`}
              label=""  className="dateInput"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputLabel shrink>
            Miasto
            </InputLabel>
            <TextField
              name={`${name}.city`}
              type="text"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputLabel shrink className="no-margins">
            Opis doświadczenia i obowiązków
            </InputLabel>
            <WysiwygEditor
              name={`${name}.description`}
              type="text"
              label="Opis"
            />
          </Grid>
        </Grid>
      )}
    />
  </FormSection>
)

export default Employment